import { captureMessage, Severity } from "@sentry/browser";

export { Severity };
export const reportToSentry = (message: string, severity: Severity = Severity.Log): string =>
  captureMessage(message, severity);
